<div [ngStyle]="{ 'width.px': size, 'height.px': size }">
  <ng-container *ngIf="logoId; else defaultCompanyLogo">
    <img *ngIf="logoId | tcObjectStorage:{ w: size } | async as file; else defaultCompanyLogo" [src]="file.downloadUrl">
  </ng-container>

  <ng-template #defaultCompanyLogo>
    <img src="assets/Tradecloud-icon.png">
  </ng-template>
</div>
